<template>
  <div class="section-title-container">
    <h2 class="section-title">{{ title }}</h2>
    <!-- <div class="bottom-line"></div> -->
  </div>
</template>

<script>
export default {
  name: "Bar",
  props: {
    title: String,
  },
};
</script>

<style scoped></style>
